import { UiState } from '@marketplace-web/shared/ui-state-util'
import { DataState } from '@marketplace-web/catalog/catalog-data'

import { DataAction, DataReducerAction } from './actionTypes'

export const dataReducer = (state: DataState, action: DataAction): DataState => {
  switch (action.type) {
    case DataReducerAction.FETCH_DATA_REQUEST: {
      return {
        ...state,
        uiState: UiState.Pending,
      }
    }
    case DataReducerAction.FETCH_DATA_SUCCESS: {
      const { catalogs, catalogTree } = action.payload

      return {
        ...state,
        uiState: UiState.Success,
        catalogs,
        catalogTree,
      }
    }
    case DataReducerAction.FETCH_DATA_FAILURE: {
      return {
        ...state,
        uiState: UiState.Failure,
      }
    }
    default:
      return state
  }
}
